import { useMediaQuery } from "@mantine/hooks"

export const useDynamicHeight = () => {
  const isMobile = useMediaQuery("(max-width: 768px)")
  const isTablet = useMediaQuery("(max-width: 1024px)")
  const isLaptop = useMediaQuery("(max-width: 1440px)")

  let tableHeight = "calc(100dvh - 160px)" // Monitors (default)
  let modalTableHeight = "calc(100dvh - 420px)" // Modal height (default)
  let isCompact = true
  if (isMobile) {
    tableHeight = "calc(100dvh - 150px)" // Mobile phones
    modalTableHeight = "calc(100dvh - 350px)"
    isCompact = true
  } else if (isTablet) {
    tableHeight = "calc(100dvh - 180px)" // Tablets
    modalTableHeight = "calc(100dvh - 400px)"
    isCompact = true
  } else if (isLaptop) {
    tableHeight = "calc(100dvh - 150px)" // Laptops
    modalTableHeight = "calc(100dvh - 400px)"
    isCompact = true
  }

  return { tableHeight, modalTableHeight, isCompact }
}
